import React from 'react';
import { TutorialProvider } from '../../contexts/TutorialContext';
import TutorialTooltip from './TutorialTooltip';

/**
 * TutorialWrapper - Wraps children with tutorial functionality.
 * Must be used inside a Router component since TutorialProvider uses useNavigate.
 */
const TutorialWrapper = ({ children }) => {
    return (
        <TutorialProvider>
            {children}
            <TutorialTooltip />
        </TutorialProvider>
    );
};

export default TutorialWrapper;
